import { CloudSlash } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AttributeStatus } from 'companySettings/enums';
import { usePartFinderFamilyActions } from 'companySettings/hooks';
import { IPartFinderFamily } from 'companySettings/types';
import { Button, Confirmation } from 'core/components';
import { NotificationPosition } from 'core/enums';
import { useAgGridClientTableContext } from 'core/states';
import { Color, Variant } from 'theme/enums';

// The statuses of a family the finder serves: a published one, or a modified one (its release
// stays on the finder while its draft is edited).
const ON_FINDER_STATUSES = [AttributeStatus.PUBLISHED, AttributeStatus.MODIFIED];

// Takes the selected families that are on the finder off it; the others are left as they are. They
// stay in the list with their versions, and publishing one puts it back.
export const UnpublishPartFinderFamiliesButton = () => {
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const { t } = useTranslation();

  const { selectedRows } = useAgGridClientTableContext();
  const { unpublishPartFinderFamilies } = usePartFinderFamilyActions(NotificationPosition.TOP);

  const families = ((selectedRows ?? []) as IPartFinderFamily[]).filter((row) =>
    ON_FINDER_STATUSES.includes(row.status)
  );

  const onUnpublish = () => {
    setIsConfirmationOpen(false);

    unpublishPartFinderFamilies(families.map((family) => family.id));
  };

  return (
    <>
      <Button
        text={t('buttonLabelUnpublish')}
        variant={Variant.SOFT}
        color={Color.NEUTRAL}
        startDecorator={<CloudSlash />}
        disabled={!families.length}
        onClick={() => setIsConfirmationOpen(true)}
      />

      <Confirmation
        isOpen={isConfirmationOpen}
        color={Color.WARNING}
        title={t('titleUnpublishPartFinderFamilies', { count: families.length })}
        message={t('messageConfirmUnpublishPartFinderFamilies', {
          count: families.length,
          name: families[0]?.name,
        })}
        confirmBtnLabel={t('buttonLabelUnpublish')}
        onConfirm={onUnpublish}
        onCancel={() => setIsConfirmationOpen(false)}
      />
    </>
  );
};
